import type { NotificationsFeatureConfig } from './type';

export const config: NotificationsFeatureConfig = {
    filterNotificationTypes: [
        'BALANCE_WD',
        'INCOMING_TRX',
        'OUTGOING_TRX',
        'CARDS',
        'MISC',
        'SECURITIES_QUOTATION_ALERT',
        'SECURITIES_ORDER_STATUS',
        'REG_924',
    ],
};
